import { render, staticRenderFns } from "./dataCount.vue?vue&type=template&id=cc550f1c&scoped=true&"
import script from "./dataCount.vue?vue&type=script&lang=js&"
export * from "./dataCount.vue?vue&type=script&lang=js&"
import style0 from "./dataCount.vue?vue&type=style&index=0&id=cc550f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc550f1c",
  null
  
)

export default component.exports